import React, { useEffect, useState } from 'react'
import { userSelector } from '../../store/userSlice'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import Header from '../components/header';
import DataItem from './components/dataItem';
import CustomButton from '../../components/customButton';
import ReservationTrimestreChart from './components/reservationTrimestreChart';
import axios from 'axios';
import getEnvironement from '../../environnement';
import ReservationDepartmentChart from './components/reservationDepartementChart';

export default function Dashboard() {
  const [outlined, setOutlined] = useState(0);

  const [badgeNotification, setBadgeNotification] = useState(0);
  const [reservationsNotification, setReservationsNotification] = useState([]);
  const [messagesNotification, setMessagesNotification] = useState([]);

  const [isLoader, setIsLoader] = useState(false);
  const [dashboardData, setDashboardData] = useState([]);

  const [year, setYear] = useState(new Date().getFullYear());

  const user = useSelector(userSelector);
  const navigate = useNavigate();

  const data = [
    {id: 1, label: 'Nombre total de demande :', value: dashboardData.nombreTotalReservation},
    {id: 2, label: 'Nombre de demande en attente de traitement :', value: dashboardData.nombreReservationEnCours},
    {id: 3, label: 'Nombre de demande accéptée et confirmée :', value: dashboardData.nombreReservationAccepteeConfirmee},
    {id: 4, label: 'Nombre de demande accéptée non confirmée :', value: dashboardData.nombreReservationAccepteeNonConfirmee},
    {id: 5, label: 'Nombre de demande refusée :', value: dashboardData.nombreReservationRefusee},
    {id: 6, label: 'Nombre de message pas encors traité :', value: dashboardData.nombreMessagesNonTraite},
  ];

  const [trimestreReservation, setTrimestreReservation] = useState([]);
  const [departementReservation, setDepartementReservation] = useState([]);

  async function getNotificationData() {
    const url = `${getEnvironement().API_URL}/notificationData`;
    await axios.post(url)
      .then((res) => {
        setReservationsNotification(res.data.reservations);
        setMessagesNotification(res.data.messages);
      })
      .then(() => setBadgeNotification(reservationsNotification.length + messagesNotification.length))
      .catch(() => {});
  }

  async function getDashboardData() {
    const url = `${getEnvironement().API_URL}/getDashboardData`;
    const data = {
      year
    };
    const config ={
      headers: {
        'Content-Type': 'application/json'
      }
    };

    setIsLoader(true);
    await axios.post(url, data, config)
      .then((res) => {
        setDashboardData(res.data.dashboardData);
        setTrimestreReservation(res.data.trimestreReservation);
        setDepartementReservation(res.data.departementReservation);
      })
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }

  useEffect(() => {
    getDashboardData();
  }, []);

  useEffect(() => {
    getDashboardData();
  }, [year]);

  useEffect(() => {
    setBadgeNotification(reservationsNotification.length + messagesNotification.length);
  }, [reservationsNotification, messagesNotification]);

  useEffect(() => {
    getNotificationData();
  }, []);

  useEffect(() => {
    if (user === null) {
      navigate('/admin');
    }
  }, [navigate, user]);

  return (
    <div className='h-screen flex flex-col'>
      <Header
        activeItem='Dashboard'
        reservations={reservationsNotification}
        messages={messagesNotification}
        badgeNotification={badgeNotification}
      />
      <div className='w-full 3xl:flex 3xl:justify-center flex-grow'>
        <div className='3xl:w-[1200px] px-10 py-5 3xl:py-5 3xl:px-0 flex flex-col lg:flex-row h-full gap-5 items-center flex-col-reverse'>
          <div className='w-full lg:w-[480px] lg:h-[70.5vh] 2xl:h-[490px] flex flex-col gap-3 overflow-visible lg:overflow-y-scroll 2xl:overflow-visible lg:pr-5'>
            {data.map((item) => {
              return (<DataItem key={item.id} label={item.label} value={item.value} isLoader={isLoader} />);
            })}
          </div>
          <div className='flex flex-col flex-grow h-[70vh] 2xl:h-[490px]'>
            <div className='flex justify-between gap-2'>
              <CustomButton
                value='Nombre de réservation par trimestres'
                outlined={outlined !== 0}
                admin
                handelClick={() => setOutlined(0)}
              />
              <CustomButton
                value='Nombre de réservation par département'
                outlined={outlined !== 1}
                admin
                handelClick={() => setOutlined(1)}
              />
            </div>
            <div className='flex-grow border-2 rounded-[10px] border-primary'>
              {outlined === 0 && (<ReservationTrimestreChart
                data={trimestreReservation}
                year={year}
                setYear={setYear}
              />)}
              {outlined === 1 && (<ReservationDepartmentChart
                data={departementReservation}
                year={year}
                setYear={setYear}
              />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
